import { Component, OnInit, Directive } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

import { SessionService } from '../../../services/session.service';

import { Caja } from '../../../models/caja';
import { CajaService } from '../../../services/caja.service';
import { AsyncLocalStorage } from 'angular-async-local-storage';

import { Validation } from '../../../config/validation';
import { SweetMessage } from '../../../config/sweet-message';

import { Empresa } from "../../../models/empresa";
import { EmpresaService } from "../../../services/empresa.service";
import { Sucursal } from "../../../models/sucursal";
import { SucursalService } from "../../../services/sucursal.service";
import { Usuario } from "../../../models/usuario";
import { UsuarioService } from "../../../services/usuario.service";

declare var $: any;
declare var JQuery: any;

@Component({
	selector: 'app-caja-edit',
	templateUrl: './caja-edit.component.html',
	styleUrls: ['./caja-edit.component.css'],
	providers: [CajaService,EmpresaService,SucursalService,UsuarioService,SessionService],
})
export class CajaEditComponent implements OnInit {
	public title: String;
	public caja;
	public sucursales: Array<Sucursal>;
	public empresa: Empresa;
	public cajero: Usuario;
	public msg: SweetMessage;
	myForm: FormGroup;
	public vl: Validation;
	public loading = false;

	constructor(
		private cajaService: CajaService,
		private empresaService: EmpresaService,
		private sucursalService: SucursalService,
		private usuarioService: UsuarioService,
		private storage: AsyncLocalStorage,
		private ss: SessionService,
		public fb: FormBuilder,
	) {
		this.title = "Caja";
	}


	getEmpresa(){
		this.loading = true;
		this.empresaService.getById(1).subscribe(
			res=>{
				this.loading = false;
				this.empresa = res;
			},
			er =>{
				this.loading = false;
			})
	}

	getSucursales(){
		this.loading = true;
		this.sucursalService.getAll().subscribe(
			res => {
				this.loading = false;
				if( res.data.length ){
					this.sucursales = res.data;
				}else{
					this.sucursales = [];
				}	
			},
			err => {
				this.loading = false;
				this.sucursales = [];
			}
		);
	}

	/*onSearch() {
		let cajero_id = this.myForm.controls['cajero_id'].value;
	//	this.setValueForm();
		if (cajero_id != null && cajero_id.trim() != '')
			this.usuarioService.getById(cajero_id).subscribe(
				res => {
					if (res.length > 0) {
						this.cajero = res[0];
						this.setValueForm();
					}
					else {
						this.openDialog()
					}
				}, err => { this.openDialog() });
		else {
			this.openDialog();
		}
	}*/

	/*openDialog() {
		$('#usuario-modal').appendTo("body").modal('show');
	}*/


	/*sendCajero(event) {
		//obtencion del cajero que envia el componente cajero-modal
		this.cajero = event;
		this.setValueForm();
	}*/


	ngOnInit() {
		//Inicializar Formulario
		this.onForm();
		//Inicializacion de Objectos
		this.msg = new SweetMessage();
		//Inicializacion de Objecto de validacion
		this.vl = new Validation();
		//Inicializacion de objecto Precio de Producto
		this.caja = new Caja();
		this.getSucursales();
		this.storage.getItem("caja").subscribe(data => {
			this.caja = data;
			this.setValueForm();
		});
	}

	onSubmit() {
		//setea valores del formulario a la entidad
		this.setValueEntity();
		this.loading = true;
		this.cajaService.update(this.caja).subscribe(
			res => {
				this.loading = false;
				this.msg.showMessage('success-message', res.message);
				//this.caja = new Caja();
				//this.onForm();
			},
			err => {
				this.loading = false;
				this.msg.showMessage('error-message', err);
			}
		);
	}

	onForm() {
		this.myForm = this.fb.group({
			nombre:['', [Validators.required,Validators.pattern(/[A-Za-z0-9\s]*/)]],
			punto_emision:['', [Validators.required,Validators.pattern(/[0-9]/),Validators.minLength(3)]],
			sucursal_id:['', [Validators.required]],
			//codigo: ['', [Validators.required,Validators.pattern(/[A-Za-z0-9\s]*/)]],
			//cajero_id: [{ value: '', disabled: true }, [Validators.required]]
		});
	}

	setValueForm() {
		this.myForm.patchValue({
			nombre: this.caja.nombre,
			punto_emision: this.caja.punto_emision,
			sucursal_id: this.caja.sucursal_id,
			//cajero_id: this.caja.cajero,
			//codigo: this.caja.persona_id,
		});
	}
	setValueEntity() {
		this.caja.empresa_id = "1";
		this.caja.nombre = this.myForm.controls['nombre'].value;
		this.caja.punto_emision = this.myForm.controls['punto_emision'].value;
		this.caja.sucursal_id = this.myForm.controls['sucursal_id'].value;
		//this.caja.cajero_id = this.cajero.id;
		this.caja.usuario_id = this.ss.getData('usuario_id');
	}

	validErrorForm(campo) {
		return this.vl.validErrorForm(campo, this.myForm);
	}

	validTypeMsgForm(nombre, campo) {
		return this.vl.validTypeMsgForm(nombre, campo, this.myForm);
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/caja-edit/caja-edit.component.ts